'use-strict'
import app from '../../../data/base';
import moment, {normalizeUnits} from 'moment';

const validateRequiredField = (inputvalue) => {
  if (inputvalue == null || inputvalue == '') {
    return false;
  } else
    return true;
}

const validateGruppo = (inputobject) => {
  const result = [];

  if (!validateRequiredField(inputobject.name)) {
    result.push({field: 'Nome', error: 'Campo obbligatorio'});
  }

  return result;

}



const gruppi = {
  auth: {
    onAuthStateChanged: app.auth.onAuthStateChanged
  },
  methods: {
    callserver: app.methods.callserver,
    validateGruppo: validateGruppo

  }
};
export default gruppi;
